import * as actionTypes from './actionTypes';
import * as propertyService from './service';
import makeCalculations from '../../../Hooks/makeCalculations';
import { commissionFromNet, dividerFor } from '../../../Util/pricingPolicy';
import { basePriceStay } from '../../../Util/basePriceStay';
import { searchStay } from '../../../Util/searchStay';
import { applyMarkupFx } from '../../../Util/quotePricing';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { currentSortBy } from '../../../Util/searchSort';

const log = require("loglevel").getLogger("PropertyActions");
log.setLevel("debug");

export const updateSearchValues = (data) => {
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.UPDATE_SEARCH_VALUES,
			data
		});
	}
}
export const updatePropertyfromlink = (status) => {
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.UPDATE_PROPERTY_FROM_LINK,
			data: status
		});
	}
}

export const loadProperty = (propertyId) => {
    return async (dispatch) => {
        // Start loading
		await dispatch({
			type: actionTypes.LOADING_PROPERTIES,
			data: true
		});
		console.log('LOADING_PROPERTY');
            const response = await propertyService.loadProperty(propertyId);

            if (response && response.listings && response.listings.length > 0) {
                const propertyData = response.listings[0];
                localStorage.setItem("property", JSON.stringify(propertyData));
            } else {
                log.error("No property data found in the response.");
            }
     setTimeout(async() => {
		await dispatch({
			type: actionTypes.PROPERTIES_LOADED,
			data: response
		});

	 }, 2000)
    };
};

export const updateSearchParams = (data) => {
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.UPDATE_SEARCH_PARAMS,
			data
		});
	}
}

export const toggleMapInSearch = (status) => {
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.UPDATE_SHOWINMAPSEARCH,
			data: !status
		});
	}
}

export const addToInteractiveMapListings = () => {
	return async (dispatch, getState) => {
		const state = getState();
		const properties = state?.property?.properties;
		console.log('has props', properties?.length)
		await dispatch({
			type: actionTypes.INTERACTIVE_MAP_LISTINGS,
			data: properties.listings
		});
	}
}

export const setInteractiveMapContinentCountries = (countries) => ({
    type: 'SET_INTERACTIVE_MAP_CONTINENT_COUNTRIES',
    payload: countries
});

export const setAllActiveCountries = () => {
	return async(dispatch) => {
		const data = await propertyService.loadAllActiveCountries();
		if(data.success && data.countries.length) {
			await dispatch({
				type: actionTypes.SET_ALL_ACTIVE_COUNTRIES,
				data: data.countries
			});
		} 
	}
}

export const loadlocationsbycountries = (country) => {
	return async(dispatch) => {
		const data = await propertyService.loadlocationsbycountry(country)
		// console.log('ppv - map loc',data)
		if(data.length) {
			await dispatch({
				type: actionTypes.INTERACTIVE_MAP_LOCATION,
				data
			});
		}
	}
}

export const loadfullcalendar = (propertyId) => {
  return async (dispatch) => {
    try {
      const response = await propertyService.loadfullcalendar(propertyId);
      return response;
    } catch (error) {
      console.error('Error loading full calendar:', error);
      throw error;
    }
  };
};

export const loadlistingsbylocation = (location) => {
	return async(dispatch) => {
		const data = await propertyService.loadlistings(location)
		// console.log('ppv - map list',data)
		if(data.length) {
			await dispatch({
				type: actionTypes.INTERACTIVE_MAP_LISTINGS,
				data
			});
		}
	}
}

// Map viewport search ("search this area"): fetch listings within the current
// map bounds + the active header filters, via the same /local/listings-search
// engine, and feed them to the interactive-map markers.
let latestBoundsSeq = 0;
export const loadListingsByBounds = (bounds) => {
	return async (dispatch, getState) => {
		const mySeq = ++latestBoundsSeq; // latest-wins across rapid pans
		const state = getState();
		const search = state.property?.search || {};
		const advancedFilters = {
			priceRanges:   search.selectedPrices    || [],
			propertyTypes: search.selectedTypes     || [],
			mustHaves:     search.selectedMusthave  || [],
			amenities:     search.selectedAmenities || [],
		};
		dispatch({ type: actionTypes.INTERACTIVE_MAP_LISTINGS_LOADING, data: true });
		try {
			// `bounds` is already snapped to the shared grid by the caller
			// (SearchMaps), so revisiting a region hits the FE/BE cache — no
			// skipCache here.
			const res = await propertyService.loadProperties(0, advancedFilters, { bounds, limit: 100, noCals: 'yes' });
			// A newer viewport search started while we awaited — drop this stale result.
			if (mySeq !== latestBoundsSeq) return;
			if (res && Array.isArray(res.listings)) {
				await dispatch({
					type: actionTypes.INTERACTIVE_MAP_LISTINGS,
					data: res.listings
				});
			}
		} catch (err) {
			if (err?.name === 'SearchSupersededError') return;
			console.error('loadListingsByBounds error:', err);
		} finally {
			// Only the latest in-flight request clears the spinner, so a slow
			// stale response can't hide the spinner while a newer fetch runs.
			if (mySeq === latestBoundsSeq) {
				dispatch({ type: actionTypes.INTERACTIVE_MAP_LISTINGS_LOADING, data: false });
			}
		}
	}
}

// Map viewport points ("show all properties as clusters"): fetch EVERY listing
// within the current bounds + active filters as lightweight points (id+coords+
// title/price/thumb) so the map clusters all of them, uncapped. Separate from
// loadListingsByBounds, which still feeds the (paginated) side card list.
let latestPointsSeq = 0;
export const loadInteractiveMapPoints = (bounds) => {
	return async (dispatch, getState) => {
		const mySeq = ++latestPointsSeq; // latest-wins across rapid pans
		const state = getState();
		const search = state.property?.search || {};
		const advancedFilters = {
			priceRanges:   search.selectedPrices    || [],
			propertyTypes: search.selectedTypes     || [],
			mustHaves:     search.selectedMusthave  || [],
			amenities:     search.selectedAmenities || [],
		};
		dispatch({ type: actionTypes.INTERACTIVE_MAP_POINTS_LOADING, data: true });
		try {
			const res = await propertyService.loadProperties(0, advancedFilters, { bounds, pointsOnly: true, skipCache: true });
			if (mySeq !== latestPointsSeq) return; // a newer viewport superseded this
			if (res && Array.isArray(res.points)) {
				await dispatch({
					type: actionTypes.INTERACTIVE_MAP_POINTS,
					data: res.points
				});
			}
		} catch (err) {
			if (err?.name === 'SearchSupersededError') return;
			console.error('loadInteractiveMapPoints error:', err);
		} finally {
			if (mySeq === latestPointsSeq) {
				dispatch({ type: actionTypes.INTERACTIVE_MAP_POINTS_LOADING, data: false });
			}
		}
	}
}

export const resetInteractiveMapPoints = () => {
	return async (dispatch) => {
		await dispatch({ type: actionTypes.INTERACTIVE_MAP_POINTS, data: [] });
	}
}

export const resetInteractiveMapListings = () => {
	return async(dispatch) => {
		await dispatch({
			type: actionTypes.INTERACTIVE_MAP_LISTINGS,
			data: []
		});
	}
}
export const resetInteractiveMapLocations = () => {
	return async(dispatch) => {
		await dispatch({
			type: actionTypes.INTERACTIVE_MAP_LOCATION,
			data: []
		});
	}
}

export const setInteractiveMapSelectedContinent = (continent) => {
	return async(dispatch) => {
		await dispatch({
			type: actionTypes.INTERACTIVE_MAP_SELECTED_CONTINENT,
			data: continent
		});
	}
}
export const IMaplastViewedcountry = (data) => {
	return async(dispatch) => {
		await dispatch({
			type: actionTypes.INTERACTIVE_MAP_LAST_VIEWED_COUNTRY,
			data
		});
	}
}

export const IMapsetSelectedListing  = (property) => {
	return async (dispatch, getState) => {
		if(!property) {
			await dispatch({
				type: actionTypes.SET_SELECTED_LISTING,
				data: false
			});
		} else {
			console.log('seletcted property here')
			const fullCalendarRes = await propertyService.loadfullcalendar(property.listing._id)
			// property.fullCalendar = fullCalendarRes
			const newProperty = { ...property, fullCalendar: fullCalendarRes };
		
			// console.log('selected property fullcalendar',property )
			const agentInfo = JSON.parse(localStorage.getItem("agent") || "{}");
			const agentCurrency = agentInfo?.currency;
			// console.log('selected property fullcalendar',agentCurrency )
			
			const priceObj = makeCalculations({
				property: newProperty.listing,
				fullCalendar: newProperty.fullCalendar,
				dateFrom: localStorage.getItem("dateFrom"),
				dateTo: localStorage.getItem("dateTo"),
				children: parseInt(localStorage.getItem("children") || "0"),
				adults: parseInt(localStorage.getItem("adults") || "2"),
				currency: agentCurrency || "USD",
			});

			console.log('selected property fullcalendar', priceObj)
			const data = {
					...newProperty,
					calculatedPrice: priceObj,
					totalprice: Number(priceObj?.totalAmount) || 0 // fees + taxes already inside totalAmount
				}
			console.log(data)
			await dispatch({
				type: actionTypes.SET_SELECTED_LISTING,
				data
			});
		}
		
	}
}

// Shared card-price enhancement for search pages: computes calculatedPrice /
// totalprice per listing (makeCalculations over the sliced fullCalendar) and
// applies the client-side sort. Used by loadProperties.
export const enhanceAndSortListings = (properties, currencyCode, sortBy) => {
	const enhancedProperties = {
		...properties,
		listings: properties.listings.map((property) => {
			const priceObj = makeCalculations({
				property: property.listing,
				fullCalendar: property.fullCalendar,
				dateFrom: localStorage.getItem("dateFrom"),
				dateTo: localStorage.getItem("dateTo"),
				children: parseInt(localStorage.getItem("children") || "0"),
				adults: parseInt(localStorage.getItem("adults") || "2"),
				currency: currencyCode,
			});

			// A DATED search whose card has no calendar (the merged search ships none) cannot be
			// priced from the calendar: makeCalculations returns 0, or — for listings with fees —
			// the fees alone. Such a card shows the base price for the stay instead, like a card
			// makeCalculations could not price at all.
			const hasDates = Boolean(localStorage.getItem("dateFrom") && localStorage.getItem("dateTo"));
			const datedWithoutCalendar = hasDates && !(Array.isArray(property.fullCalendar) && property.fullCalendar.length);
			// If totalAmount is 0, use the base price from the property
			if (datedWithoutCalendar || !priceObj?.totalAmount || priceObj.totalAmount === 0) {
				const basePrice = property.listing?.prices?.basePriceUSD ||
					property.listing?.prices?.basePrice ||
					0;
				const dateFrom = localStorage.getItem("dateFrom");
				const dateTo = localStorage.getItem("dateTo");
				let numberOfDays = 1;
				if (dateFrom && dateTo) {
					const startDate = new Date(dateFrom);
					const endDate = new Date(dateTo);
					numberOfDays = Math.max(1, Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24)));
					// The Flexible tab stores a whole month as the dates: that is the window to look
					// in, not the stay. The stay is the nights asked for (Util/searchStay.js).
					const stay = searchStay();
					if (stay.datesAreAWindow && stay.nights > 0) numberOfDays = stay.nights;
				}
				// The card shows the SELLING price: net x markup (Util/pricingPolicy — x1.22, or x1.10
				// for the SHM account), like every other card price. The hubs' price filter uses the
				// same figure (VTHub/SHub api/utils/priceBudget.js datedBudgetStages). The
				// reservation figure (RES) stays net.
				// The base is in dollars (or the villa's own currency), and the card prints it under
				// the SELECTED currency's symbol, so it is converted into that currency here. It was
				// not, and the same card read $2,247, then EUR 2,247, then ILS 2,247.
				const stay = basePriceStay({
					prices: property.listing?.prices,
					accountId: property.listing?.accountId,
					nights: numberOfDays,
					displayCurrency: currencyCode,
				});
				priceObj.totalAmount = stay.totalAmount;
				priceObj.totalAmountRES = basePrice * numberOfDays;
				// Fees-only "taxes" from a calendar-less run are not part of a base-price total.
				priceObj.totalTaxes = datedWithoutCalendar ? 0 : (priceObj?.totalTaxes || 0);
				priceObj.totalTaxesRES = datedWithoutCalendar ? 0 : (priceObj?.totalTaxesRES || 0);
				// makeCalculations computed agencyCommission while totalAmount was still 0,
				// so it's stale at 0 — recompute it on the base we just patched in (basePrice
				// is the NET rate; the commission is on the price it sells at). Without this the
				// card shows a price but "$0 agency commission" for every listing.
				priceObj.agencyCommission = stay.agencyCommission;
				priceObj.agencyCommissionRES = commissionFromNet(basePrice * numberOfDays, dividerFor(property.listing?.accountId));
			}

			// SearchProperty render guards drop cards where !totalprice/isNaN (per client
			// demand: no-price cards stay hidden). Make totalprice NaN-proof so the guard
			// only fires for genuinely missing-price data. Deep-clone priceObj:
			// makeCalculations returns closure-captured arrays that some async axios
			// callbacks mutate AFTER the synchronous return; without the clone those
			// mutations land inside Redux state and trip the immutable-state middleware.
			// totalAmount already includes fees and taxes (totalTaxes is the same money
			// reported again for the breakdown) — never add the two.
			const safeAmount = Number.isFinite(Number(priceObj?.totalAmount)) ? Number(priceObj.totalAmount) : 0;
			let totalprice = safeAmount;
			if (!totalprice || !Number.isFinite(totalprice)) {
				const dateFrom = localStorage.getItem("dateFrom");
				const dateTo = localStorage.getItem("dateTo");
				let days = 1;
				if (dateFrom && dateTo) {
					days = Math.max(1, Math.ceil((new Date(dateTo) - new Date(dateFrom)) / 86400000));
				}
				// selling, as above, and in the selected currency like it
				totalprice = basePriceStay({
					prices: property.listing?.prices,
					accountId: property.listing?.accountId,
					nights: days,
					displayCurrency: currencyCode,
				}).totalAmount;
			}
			return {
				...property,
				calculatedPrice: structuredClone(priceObj),
				totalprice,
			};
		})
	};

	let listings = enhancedProperties.listings;
	if (sortBy && typeof sortBy === "string" && sortBy.includes(":")) {
		const [fieldPath, order] = sortBy.split(":");
		const sortOrder = parseInt(order, 10); // 1 for asc, -1 for desc
		listings = [...listings].sort((a, b) => {
			const aOnDemand = a.listing?.tags?.includes("onDemand") ? 1 : 0;
			const bOnDemand = b.listing?.tags?.includes("onDemand") ? 1 : 0;
			if (aOnDemand !== bOnDemand) return aOnDemand - bOnDemand; // non-onDemand first
			// Best-effort tag ranking beats the price/bedroom sort: listings that
			// match more of the guest's picked filters come first; the chosen sort
			// applies within equal match counts.
			const aMatch = a.listing?._tagMatch?.count || 0;
			const bMatch = b.listing?._tagMatch?.count || 0;
			if (aMatch !== bMatch) return bMatch - aMatch;
			let aValue, bValue;
			if (fieldPath === "data.prices.basePrice") {
				aValue = a.totalprice;
				bValue = b.totalprice;
			} else if (fieldPath === "data.bedrooms") {
				aValue = a.listing?.bedrooms;
				bValue = b.listing?.bedrooms;
			} else {
				aValue = 0;
				bValue = 0;
			}
			if (aValue == null) aValue = 0;
			if (bValue == null) bValue = 0;
			if (aValue < bValue) return -1 * sortOrder;
			if (aValue > bValue) return 1 * sortOrder;
			return 0;
		})
	}
	enhancedProperties.listings = listings;
	return enhancedProperties;
};

export const loadProperties = (pageNumber, pagesize = 12, selectedcurrency) => {

	return async (dispatch, getState) => {
// const startTime= performance.now(); //By Jaison.

		log.debug("PropertyActions -> loadProperties -> Enter");

		await dispatch({
			type: actionTypes.LOADING_PROPERTIES,
			data: true
		});
		
		const state = getState();
		// The same sort the SortByDropdown shows and the request sends (Util/searchSort.js):
		// the agent's choice, else the shared default — price Low to High.
		const sortBy = state.property?.search?.sortBy || currentSortBy();
		// Admin source filter ('all' | 'vt' | 'sh') — restricts the merged search to one backend.
		const sourceFilter = state.property?.search?.sourceFilter || 'all';
		const showMapinSearch = state.property.ShowMapInSearch

		const currencyCode = selectedcurrency || "USD";
        // const exchangeRate = getExchangeRateFromLocalStorage(currencyCode);

		const search = state.property?.search || {};
		const advancedFilters = {
			priceRanges:   search.selectedPrices    || [],
			propertyTypes: search.selectedTypes     || [],
			mustHaves:     search.selectedMusthave  || [],
			amenities:     search.selectedAmenities || [],
		};

		let properties;
		try {
			properties = await propertyService.loadProperties(pageNumber, advancedFilters, { sourceFilter });
		} catch (err) {
			if (err?.name === 'SearchSupersededError') {
				// A newer request has taken over; let it resolve and dispatch.
				return;
			}
			console.error('PropertyActions -> loadProperties -> error:', err);
			await dispatch({ type: actionTypes.LOADING_PROPERTIES, data: false });
			return;
		}
		const enhancedProperties = enhanceAndSortListings(properties, currencyCode, sortBy);
		// if(showMapinSearch) {
			await dispatch({
				type: actionTypes.INTERACTIVE_MAP_LISTINGS,
				data: enhancedProperties.listings
			});
		// }
		await dispatch({
			type: actionTypes.PROPERTIES_LOADED,
			data: enhancedProperties
		});
		// Non-blocking: cards are already rendered on the stored price above. Overlay the
		// live-quote price a moment later (fire-and-forget — never awaited, so zero effect
		// on time-to-first-render). See overlayLiveSearchPrices.
		dispatch(overlayLiveSearchPrices(currencyCode));
	}

};

// ─── Live-price overlay for search cards (zero render-speed cost) ─────────────
// Cards render INSTANTLY on the stored calendar price (enhanceAndSortListings,
// untouched). AFTER that, this fires ONE batch live-quote per origin hub and, for
// each channel listing whose live quote is positive, overlays the live price onto
// the already-rendered card — so the card, the selection, and the offer show the
// SAME number the property detail page (live quote) does. The reported bug: a card
// priced €7,686 (stored) while its detail page priced €8,071 (live), and the offer
// froze the stale €7,686 the client then saw contradicted on click-through.
//
// It only ever REPLACES a price with a strictly-positive live one (applyMarkupFx
// returns null on any bad/zero net or missing FX), and the reducer drops anything
// non-positive — so a card can never be zeroed: worst case it keeps its stored,
// already >0-guarded price. Channels that drift stored-vs-live: Guesty/RU/BP/HW.
const isLiveQuoteChannel = (id) =>
	/^(G-|RU-|BP-|HW-)/.test(String(id || ''));

// The currency the live prices are asked for and written in: the one the search just priced
// its cards in. It used to be the agent's PROFILE currency first, so an agent whose profile is
// in shekels and who chose dollars or euros on the search page got the shekel figure under the
// chosen symbol: "$70,579 = ₪70,621 = €70,621" (Villa Tracker fix check, 12 Oct 2026). Only
// villas with a live quote were touched, which is why the others converted correctly.
export const liveQuoteCurrency = (searchCurrency, { stored, profile } = {}) =>
	searchCurrency || stored || profile || 'USD';

export const overlayLiveSearchPrices = (searchCurrency) => {
	return async (dispatch, getState) => {
		const dateFrom = localStorage.getItem('dateFrom');
		const dateTo = localStorage.getItem('dateTo');
		// No dates → the cards show a per-night "from" price; there is no stay to
		// live-quote, so leave them exactly as rendered.
		if (!dateFrom || !dateTo) return;
		// The Flexible tab: the stored dates are a month to look in. A quote for them would be a
		// quote for a month-long stay, so there is nothing to live-quote here either.
		if (searchStay().datesAreAWindow) return;

		let agentInfo = {};
		try { agentInfo = JSON.parse(localStorage.getItem('agent') || '{}') || {}; } catch (_) { agentInfo = {}; }
		const currency = liveQuoteCurrency(searchCurrency, { stored: localStorage.getItem('currency'), profile: agentInfo?.currency });
		const guests =
			(parseInt(localStorage.getItem('adults') || '0', 10) || 0) +
			(parseInt(localStorage.getItem('children') || '0', 10) || 0) || 1;
		// Format the stay exactly as makeCalculations does for its own quote calls, so
		// the batch keys the same cache entry the detail page will hit.
		const ci = dayjs(dateFrom); const co = dayjs(dateTo);
		if (!ci.isValid() || !co.isValid()) return;
		const checkIn = ci.format('YYYY-MM-DD');
		const checkOut = co.format('YYYY-MM-DD');

		const listings = getState().property?.properties?.listings;
		if (!Array.isArray(listings) || !listings.length) return;

		// Group the channel listings that haven't already been live-verified, by their
		// origin hub (merged search stamps _source; 'SHUB' → SHUB source hub, else VTHUB).
		const byHub = { sh: [], vt: [] };
		const storedById = {};
		for (const property of listings) {
			const id = property?.listing?._id;
			if (!id || !isLiveQuoteChannel(id)) continue;
			if (property?.calculatedPrice?.liveVerified === true) continue; // already overlaid
			storedById[id] = property.calculatedPrice || {};
			const hub = String(property?.listing?._source).toUpperCase() === 'SHUB' ? 'sh' : 'vt';
			byHub[hub].push(id);
		}
		if (!byHub.sh.length && !byHub.vt.length) return;

		// One batch request per hub — cache hits return instantly, misses resolve under
		// the hub's short deadline (the rest keep warming server-side for the next tick).
		const batches = await Promise.all(
			['sh', 'vt'].map((hub) =>
				byHub[hub].length
					? propertyService.getUnifiedQuoteBatch({ listingIds: byHub[hub], checkIn, checkOut, guests, currency, srcHub: hub })
					: Promise.resolve(null),
			),
		);

		const patch = {};
		for (const res of batches) {
			const quotes = res && res.ok && res.quotes ? res.quotes : null;
			if (!quotes) continue;
			for (const id of Object.keys(quotes)) {
				const q = quotes[id];
				// Only a real, available, positive quote can overlay a card. Everything
				// else (unavailable / pending / non-positive) leaves the stored price.
				if (!q || q.ok !== true || q.available !== true || !(Number(q.netTotal) > 0)) continue;
				const r = applyMarkupFx({
					netTotal: q.netTotal,
					accountId: q.accountId,
					quoteCurrency: q.currency,   // DTO net is in this currency (we requested `currency`)
					displayCurrency: currency,
					listingId: id,               // Rentals United villas round as the villa page does
				});
				if (!r || !(r.totalAmount > 0)) continue; // never write a 0/NaN price

				// Reproduce the detail page's per-channel tax treatment WITHOUT re-deriving
				// it: makeCalculations folds taxes into totalAmount AND keeps a separate
				// totalTaxes, and BOTH scale with the net. So scale the stored breakdown by
				// the live/stored total ratio — this matches the live detail page within
				// rounding, for every channel, and preserves totalTaxes:0 for tax-free villas.
				const stored = storedById[id] || {};
				const storedTA = Number(stored.totalAmount);
				const storedTX = Number(stored.totalTaxes);
				const scale = storedTA > 0 ? r.totalAmount / storedTA : 1;
				const newTaxes = Number.isFinite(storedTX) ? storedTX * scale : 0;
				patch[id] = {
					totalAmount: r.totalAmount,
					totalTaxes: newTaxes > 0 ? newTaxes : 0,
					agencyCommission: r.agencyCommission,
					totalprice: r.totalAmount, // fee-inclusive live net with markup; taxes are inside it
				};
			}
		}

		if (Object.keys(patch).length) {
			dispatch({ type: actionTypes.PATCH_LIVE_SEARCH_PRICES, data: patch });
		}
	};
};

export const toggleOnDemandandloadProperties = (pageNumber) => {
	return async (dispatch, getState) => {
		log.debug("PropertyActions -> loadProperties toggle onDemand -> Enter");

		// Flip on-demand VISIBILITY (include <-> exclude), persist it, pass to the service.
		const hideOnDemand = localStorage.getItem("hideOnDemand") === 'true';
		const tmpHideOnDemand = !hideOnDemand;
		localStorage.setItem("hideOnDemand", tmpHideOnDemand.toString());

		const search = getState().property?.search || {};
		const advancedFilters = {
			priceRanges:   search.selectedPrices    || [],
			propertyTypes: search.selectedTypes     || [],
			mustHaves:     search.selectedMusthave  || [],
			amenities:     search.selectedAmenities || [],
		};

		const properties = await propertyService.toggleOnDemandandloadProperties(pageNumber, tmpHideOnDemand, advancedFilters);
		console.log(properties)

	}
};

export const getreservationreport = (data) => {
	// console.log(data) 
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.LOADING_RESERVATION_REPORTS,
			data: true
		});

		const reports = await propertyService.loadreservationreport(data)
		// console.log(reports)
		if(reports?.data?.status) {
			await dispatch({
				type: actionTypes.RESERVATION_REPORTS_LOADED,
				data: reports?.data?.report[0]
			});
		}
		
	}
}

export const loadFavorites = (pageNumber, admin = false, currency = false) => {
	return async (dispatch) => {
		log.debug("PropertyActions -> loadFavorites -> Enter");

		console.log('Faourites page check - ppv', admin)

		await dispatch({
			type: actionTypes.FAVORITES_LOADED,
			data: {}
		});
		await dispatch({
			type: actionTypes.LOADING_FAVORITES,
			data: true
		});

		const favorites = await propertyService.loadFavorites(pageNumber, admin);
		const enhancedProperties = {
			...favorites,
			listings: favorites.listings.map((property) => {
				const priceObj = makeCalculations({
					property: property.listing,
					fullCalendar: property.fullCalendar,
					dateFrom: localStorage.getItem("dateFrom"),
					dateTo: localStorage.getItem("dateTo"),
					children: parseInt(localStorage.getItem("children") || "0"),
					adults: parseInt(localStorage.getItem("adults") || "2"),
					currency: currency || "USD",
				});
				// console.log('ppv - priceobj from search', priceObj)
				return {
					...property,
					calculatedPrice: priceObj,
					totalprice: Number(priceObj?.totalAmount) || 0 // fees + taxes already inside totalAmount
				};
			})
		}
		console.log('fav res -ppv',enhancedProperties)
		await dispatch({
			type: actionTypes.FAVORITES_LOADED,
			data: enhancedProperties
		});
	}
};

export const getQoute = (propertyId, body) => {
	return async (dispatch) => {
		log.debug("PropertyActions -> getQoute -> Enter");

		await dispatch({
			type: actionTypes.GET_QOUTE,
			data: true
		});

		const qoute = await propertyService.getQoute(propertyId, body);

		await dispatch({
			type: actionTypes.QOUTE_LOADED,
			data: qoute
		});
	}
};

export const loadIds = (propIds) => {
	return async (dispatch) => {
		log.debug("PropertyActions -> loadIds -> Enter");

		await dispatch({
			type: actionTypes.LOADING_IDS,
			data: true
		});

		const properties = await propertyService.loadPropertiesIds(propIds);

		await dispatch({
			type: actionTypes.IDS_LOADED,
			data: properties
		});
	}
};

export const toggleProperty = property => {
	return {
		type: actionTypes.TOGGLE_SELECTED_PROPERTY,
		data: property.listing
	};
};

export const clearProperties = () => {
	return {
		type: actionTypes.CLEAR_PROPERTIES
	};
};

export const updateValidSearchDestination = (status) => {
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.VALID_SEARCH_DESTINATION_CHECK,
			data: status
		});
	}
}

export const flagWishlistModel = (status) => {
	return {
		type: actionTypes.FLAG_WISHLIST_MODEL,
		data: status
	};
}

export const setGroupMode = (enabled) => {
	return async (dispatch, getState) => {
		const state = getState();
		const wasGroup = !!state.property?.search?.isGroupMode;
		const currentMapToggle = !!state.property?.ShowMapInSearch;

		if (enabled && !wasGroup) {
			// Entering group mode: remember current map toggle, force it off
			await dispatch({
				type: actionTypes.SET_GROUP_FILTERS,
				data: { mapToggleBeforeGroup: currentMapToggle }
			});
			if (currentMapToggle) {
				await dispatch({
					type: actionTypes.UPDATE_SHOWINMAPSEARCH,
					data: false
				});
			}
		} else if (!enabled && wasGroup) {
			// Leaving group mode: restore prior map toggle.
			// Cluster results, filters, and dates are intentionally kept in state
			// so re-entering group mode shows the previous search data (mirrors
			// how the normal listings search persists across navigation).
			const prior = !!state.property?.search?.mapToggleBeforeGroup;
			if (prior !== currentMapToggle) {
				await dispatch({
					type: actionTypes.UPDATE_SHOWINMAPSEARCH,
					data: prior
				});
			}
		}

		await dispatch({
			type: actionTypes.SET_GROUP_MODE,
			data: !!enabled
		});
		persistGroupFilters(getState);
	};
};

// Persist group filters + mode so a refresh doesn't wipe them (reducer
// hydrates from this key at load). Map state stays session-only.
const persistGroupFilters = (getState) => {
	try {
		const p = getState().property || {};
		const s = p.search || {};
		localStorage.setItem('groupFilters', JSON.stringify({
			isGroupMode: !!s.isGroupMode,
			totalGuests: s.totalGuests,
			radiusKm: s.radiusKm,
			maxProperties: s.maxProperties,
			minBudget: s.minBudget,
			maxBudget: s.maxBudget,
			groupDestinations: s.groupDestinations,
			groupDateFrom: s.groupDateFrom,
			groupDateTo: s.groupDateTo
		}));
	} catch (_) { /* quota/serialization issues are non-fatal */ }
};

export const setGroupFilters = (data) => {
	return async (dispatch, getState) => {
		await dispatch({
			type: actionTypes.SET_GROUP_FILTERS,
			data
		});
		persistGroupFilters(getState);
	};
};

export const cancelClusterSearch = () => {
	return async (dispatch) => {
		propertyService.cancelClusterSearch();
		await dispatch({ type: actionTypes.CLUSTERS_CANCELLED });
	};
};

/**
 * Live-verify one cluster's prices (RU/DH XML, SH-API, Guesty) via the
 * drill-in endpoint. Estimates are replaced in place and the cluster is
 * marked verified. Returns true on success so the card can stop its spinner.
 */
export const verifyClusterPrices = (clusterIndex) => {
	return async (dispatch, getState) => {
		const state = getState();
		const cluster = state.property?.clusters?.[clusterIndex];
		const search = state.property?.search;
		if (!cluster || !Array.isArray(cluster.properties) || cluster.properties.length === 0) return false;

		const items = cluster.properties
			.filter((p) => p?.id != null)
			// src = origin hub ('vt'|'sh') so the backend verify routes SHub members
			// to SHUB's endpoint and VTHub members to VTHub's — both are group sources.
			.map((p) => ({ id: p.id, guests: p.pricedForGuests || p.listing?.accommodates || 2, src: p.src || 'vt' }));
		if (!items.length) return false;

		const res = await propertyService.verifyClusterQuotesApi({
			items,
			checkIn: search?.groupDateFrom,
			checkOut: search?.groupDateTo
		});

		if (res?.success && res.quotes) {
			await dispatch({
				type: actionTypes.CLUSTER_QUOTES_VERIFIED,
				data: { clusterIndex, quotes: res.quotes }
			});
			return true;
		}
		toast.error(res?.error || 'Price verification failed');
		return false;
	};
};

export const loadClusters = (options = {}) => {
	return async (dispatch, getState) => {
		log.debug("PropertyActions -> loadClusters -> Enter");

		await dispatch({ type: actionTypes.LOADING_CLUSTERS });

		const state = getState();
		// options.bounds ({south, west, north, east}) = map-move search: the
		// viewport replaces the form's destination scope for this request only.
		const groupSearch = options.bounds
			? { ...state.property?.search, boundsOverride: options.bounds }
			: state.property?.search;

		try {
			const res = await propertyService.loadClusters(groupSearch);

			// A newer search superseded this one (abort/sequence guard in the
			// service). Say nothing — the newer request owns the loading state.
			if (res?.superseded) {
				return;
			}

			if (res?.success) {
				await dispatch({
					type: actionTypes.CLUSTERS_LOADED,
					// requestContext = the criteria this search actually RAN with.
					// The results header must describe the priced results, not the
					// live form (which the user can edit without re-searching).
					data: {
						...res,
						requestContext: {
							destinations: (groupSearch?.groupDestinations || [])
								.map((d) => (typeof d === 'string' ? d : d?.name))
								.filter(Boolean),
							dateFrom: groupSearch?.groupDateFrom || '',
							dateTo: groupSearch?.groupDateTo || '',
							fromMapBounds: !!options.bounds
						}
					}
				});
			} else {
				// No toast here: the inline cluster-results error panel (with its
				// Retry button) is the single error surface — a toast would show
				// the same failure twice.
				const message = res?.error || 'Group accommodation search failed';
				await dispatch({
					type: actionTypes.CLUSTERS_FAILED,
					data: message
				});
			}
		} catch (err) {
			// Service normalizes its own errors; this catch is a last-resort net
			// so the spinner can never be left stuck by an unexpected throw.
			const message = err?.message || 'Group accommodation search failed';
			await dispatch({
				type: actionTypes.CLUSTERS_FAILED,
				data: message
			});
		}
	};
};

export const loadMoreClusters = () => {
	return { type: actionTypes.LOAD_MORE_CLUSTERS };
};

export const resetClusters = () => {
	return { type: actionTypes.RESET_CLUSTERS };
};

export const updateLatestProperties = (data) => {
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.UPDATE_LATEST_PROPERTIES,
			data
		});
	}
}

export const resetLatestProperties = () => {
	return async (dispatch) => {
		await dispatch({
			type: actionTypes.RESET_LATEST_PROPERTIES,
		});
	}
}

export const fetchLatestProperties = () => {
	return async (dispatch) => {
		try {
			const response = await propertyService.fetchLatestProperties();
			if (response?.data?.status && response?.data?.listings) {
				const enhancedProperties = response?.data?.listings.length ? 
					response?.data?.listings.map((property) => {
						const agentInfo = JSON.parse(localStorage.getItem("agent") || "{}");
    					const agentCurrency = agentInfo?.currency;
						const priceObj = makeCalculations({
							property: property.listing,
							fullCalendar: property.fullCalendar,
							dateFrom: localStorage.getItem("dateFrom"),
							dateTo: localStorage.getItem("dateTo"),
							children: parseInt(localStorage.getItem("children") || "0"),
							adults: parseInt(localStorage.getItem("adults") || "2"),
							currency: agentCurrency || "USD",
						});
						return {
							...property,
							calculatedPrice: priceObj,
							totalprice: Number(priceObj?.totalAmount) || 0 // fees + taxes already inside totalAmount
						};
					})
				: ([])
				

				
				dispatch(updateLatestProperties(enhancedProperties));
			} else {
				dispatch(updateLatestProperties(false));
			}
		} catch (error) {
			console.error('Failed to fetch latest properties:', error);
			dispatch(updateLatestProperties(false));
		}
	}
}
